import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import api from '../api/client';

function GuideAttendance() {
  const { user } = useAuth();
  const [records, setRecords] = useState([]);
  const [allRecords, setAllRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [absenceDate, setAbsenceDate] = useState('');
  const [absenceReason, setAbsenceReason] = useState('');
  const today = new Date().toISOString().split('T')[0];

  useEffect(() => { loadData(); }, []);

  const loadData = async () => {
    setLoading(true);
    const myData = await api.request(`guide-attendance.php?action=my&month=${today.substring(0,7)}`);
    if (myData?.attendance) setRecords(myData.attendance);
    if (user.role === 'admin') {
      const allData = await api.request(`guide-attendance.php?action=list&date=${today}`);
      if (allData?.attendance) setAllRecords(allData.attendance);
    }
    setLoading(false);
  };

  const handleCheckin = async () => {
    await api.request('guide-attendance.php?action=checkin', { method: 'POST', body: {} });
    loadData();
  };

  const handleAbsence = async () => {
    if (!absenceDate) return;
    await api.request('guide-attendance.php?action=absent', {
      method: 'POST', body: { date: absenceDate, reason: absenceReason }
    });
    setAbsenceDate('');
    setAbsenceReason('');
    loadData();
  };

  const formatDate = (d) => new Date(d).toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' });

  return (
    <div className="animate-in">
      {/* Check-in Today */}
      <div style={{ background: '#1a1a1a', borderRadius: '16px', padding: '16px', marginBottom: '12px', border: '1px solid #333' }}>
        <div style={{ fontSize: '14px', fontWeight: 600, marginBottom: '10px' }}>✅ Présence aujourd'hui</div>
        <button onClick={handleCheckin} style={{
          width: '100%', padding: '14px', background: '#10B981', color: 'white',
          border: 'none', borderRadius: '10px', fontWeight: 600, fontSize: '14px', cursor: 'pointer'
        }}>Je suis présent aujourd'hui</button>
      </div>

      {/* Declare Absence */}
      <div style={{ background: '#1a1a1a', borderRadius: '16px', padding: '16px', marginBottom: '12px', border: '1px solid #333' }}>
        <div style={{ fontSize: '14px', fontWeight: 600, marginBottom: '10px' }}>📅 Déclarer une absence</div>
        <input type="date" value={absenceDate} onChange={e => setAbsenceDate(e.target.value)}
          min={today} style={{ width: '100%', padding: '10px', background: '#2a2a2a', border: '1px solid #444', borderRadius: '8px', color: 'white', fontSize: '13px', marginBottom: '8px' }} />
        <input value={absenceReason} onChange={e => setAbsenceReason(e.target.value)}
          placeholder="Raison (optionnel)" style={{ width: '100%', padding: '10px', background: '#2a2a2a', border: '1px solid #444', borderRadius: '8px', color: 'white', fontSize: '13px', marginBottom: '8px' }} />
        <button onClick={handleAbsence} disabled={!absenceDate} style={{
          width: '100%', padding: '10px', background: absenceDate ? '#F59E0B' : '#555', color: 'white',
          border: 'none', borderRadius: '8px', fontWeight: 600, fontSize: '13px', cursor: absenceDate ? 'pointer' : 'default'
        }}>Déclarer absent</button>
      </div>

      {/* Admin: Today's attendance */}
      {user.role === 'admin' && allRecords.length > 0 && (
        <div style={{ background: '#1a1a1a', borderRadius: '16px', padding: '14px', marginBottom: '12px', border: '1px solid #333' }}>
          <div style={{ fontSize: '13px', fontWeight: 600, marginBottom: '8px' }}>👥 Présence aujourd'hui</div>
          {allRecords.map(r => (
            <div key={r.id} style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0', borderBottom: '1px solid #2a2a2a' }}>
              <span style={{ fontSize: '12px' }}>{r.guide_name}</span>
              <span style={{ fontSize: '11px', color: r.status === 'present' ? '#10B981' : '#EF4444', fontWeight: 600 }}>
                {r.status === 'present' ? `✅ ${r.check_in_time?.substring(0,5) || ''}` : `❌ ${r.reason || 'Absent'}`}
              </span>
            </div>
          ))}
        </div>
      )}

      {/* My History */}
      <div style={{ background: '#1a1a1a', borderRadius: '16px', padding: '14px', border: '1px solid #333' }}>
        <div style={{ fontSize: '13px', fontWeight: 600, marginBottom: '8px' }}>📋 Mon historique</div>
        {loading ? (
          <div style={{ textAlign: 'center' }}><div className="spinner" style={{ margin: '0 auto' }}></div></div>
        ) : records.length === 0 ? (
          <div style={{ color: '#555', fontSize: '12px' }}>Aucun enregistrement ce mois</div>
        ) : (
          records.map(r => (
            <div key={r.id} style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0', borderBottom: '1px solid #2a2a2a' }}>
              <span style={{ fontSize: '12px' }}>{formatDate(r.date)}</span>
              <span style={{ fontSize: '11px', color: r.status === 'present' ? '#10B981' : '#EF4444' }}>
                {r.status === 'present' ? '✅ Présent' : `❌ ${r.reason || 'Absent'}`}
              </span>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default GuideAttendance;
